// DI   HVAC-006
// Custom Variant Selector JavaScript - Progressive enhancement

/* DI technical-fixes — prevent browser scroll reset during option navigation */
try {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  var __pdpSavedScroll = sessionStorage.getItem('pdp-v2-option-scroll-y');
  if (__pdpSavedScroll !== null) {
    var __pdpY = parseInt(__pdpSavedScroll, 10);
    if (!isNaN(__pdpY)) {
      window.scrollTo(0, __pdpY);
    }
  }
} catch (e) {}

function initializeVariantSelectors() {
  const customVariantSelectors = document.querySelectorAll('.custom-variant-selector');
  
  if (!customVariantSelectors.length) return;
  
  customVariantSelectors.forEach(function(selector) {
    // Skip JSON-mode containers — pdp-variant-selector-json.js owns their full lifecycle
    // (loading spinner → fetch → build options → initCustomVariantSelector).
    // Calling initCustomVariantSelector here would add --empty / display:none before
    // any options exist, hiding even the loading spinner.
    if (selector.getAttribute('data-json-mode') === 'true') return;

    // Skip if already initialized
    if (selector.dataset.initialized === 'true') return;
    selector.dataset.initialized = 'true';
    
    initCustomVariantSelector(selector);
  });
}

function restoreOptionScrollPosition() {
  try {
    var saved = sessionStorage.getItem('pdp-v2-option-scroll-y');
    if (saved === null) return;
    sessionStorage.removeItem('pdp-v2-option-scroll-y');
    var y = parseInt(saved, 10);
    if (isNaN(y)) return;
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, y);
    requestAnimationFrame(function() {
      window.scrollTo(0, y);
    });
  } catch (err) {}
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    restoreOptionScrollPosition();
    initializeVariantSelectors();
    watchJsonModeContainers();
  });
} else {
  restoreOptionScrollPosition();
  initializeVariantSelectors();
  watchJsonModeContainers();
}

// Watch for dynamically added variant selectors (safety net)
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    let shouldInit = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList?.contains('custom-variant-selector') || node.querySelector?.('.custom-variant-selector'))) {
            shouldInit = true;
          }
        });
      }
    });
    if (shouldInit) {
      initializeVariantSelectors();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function sortVariantOptions(selector) {
  // Sort options within each variant selector group
  const groups = selector.querySelectorAll('.custom-variant-selector__group');
  
  groups.forEach(function(group) {
    const optionsContainer = group.querySelector('.custom-variant-selector__options');
    if (!optionsContainer) return;
    
    const optionElements = Array.from(optionsContainer.children);
    if (optionElements.length <= 1) return; // No need to sort if only one option
    
    // Sort the option elements based on their text content
    optionElements.sort(function(a, b) {
      const aText = a.textContent.trim();
      const bText = b.textContent.trim();
      
      return compareOptionValues(aText, bText);
    });
    
    // Clear the container and re-append in sorted order
    optionsContainer.innerHTML = '';
    optionElements.forEach(function(element) {
      optionsContainer.appendChild(element);
    });

    // HVAC-074-DI — keep data-option-values in DOM order after sort
    var existingValues = (group.getAttribute('data-option-values') || '').split('|').filter(Boolean);
    if (existingValues.length) {
      var synced = optionElements.map(function(element) {
        var text = element.textContent.trim();
        for (var i = 0; i < existingValues.length; i++) {
          var value = existingValues[i];
          if (value === text) return value;
          var valueCore = value.replace(/ BTU$/i, '');
          var textCore = text.replace(/ BTU$/i, '');
          if (valueCore === text || value === textCore || valueCore === textCore) return value;
        }
        return text;
      });
      group.setAttribute('data-option-values', synced.join('|'));
    }
  });
}

function compareOptionValues(a, b) {
  const aStr = String(a).trim();
  const bStr = String(b).trim();
  
  // Try to extract numeric value with units (e.g., "60K BTU", "2 Ton", "2.5 Ton")
  const aNumMatch = aStr.match(/^(\d+(?:\.\d+)?)\s*[KkTt]?\s*/);
  const bNumMatch = bStr.match(/^(\d+(?:\.\d+)?)\s*[KkTt]?\s*/);
  
  // Both have numeric values - sort numerically
  if (aNumMatch && bNumMatch) {
    const aNum = parseFloat(aNumMatch[1]);
    const bNum = parseFloat(bNumMatch[1]);
    return aNum - bNum;
  }
  
  // Try to extract percentage values (e.g., "80%", "95%")
  const aPercentMatch = aStr.match(/^(\d+(?:\.\d+)?)\s*%/);
  const bPercentMatch = bStr.match(/^(\d+(?:\.\d+)?)\s*%/);
  
  if (aPercentMatch && bPercentMatch) {
    const aNum = parseFloat(aPercentMatch[1]);
    const bNum = parseFloat(bPercentMatch[1]);
    return aNum - bNum;
  }
  
  // Try pure numeric values (e.g., "1", "2", "3")
  const aNum = parseFloat(aStr);
  const bNum = parseFloat(bStr);
  
  if (!isNaN(aNum) && !isNaN(bNum)) {
    return aNum - bNum;
  }
  
  // Custom order for configuration values
  const configOrder = ['upflow/horizontal', 'downflow/horizontal'];
  const aIdx = configOrder.indexOf(aStr.toLowerCase());
  const bIdx = configOrder.indexOf(bStr.toLowerCase());
  if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
  if (aIdx !== -1) return -1;
  if (bIdx !== -1) return 1;

  // Fall back to alphabetical sorting for text values
  return aStr.localeCompare(bStr);
}

function initCustomVariantSelector(selector) {
  // Sort options before adding event listeners
  sortVariantOptions(selector);

  // Hide groups with no options
  selector.querySelectorAll('.custom-variant-selector__group').forEach(function(group) {
    const optionsContainer = group.querySelector('.custom-variant-selector__options');
    if (!optionsContainer || !optionsContainer.children.length) {
      group.classList.add('custom-variant-selector__group--empty');
    }
  });

  // Hide container if it has no visible groups
  const visibleGroups = selector.querySelectorAll('.custom-variant-selector__group:not(.custom-variant-selector__group--empty)');
  if (!visibleGroups.length) {
    selector.classList.add('custom-variant-selector--empty');
  } else {
    selector.classList.remove('custom-variant-selector--empty');
  }

  const options = selector.querySelectorAll('.custom-variant-selector__option');

  /* DI technical-fixes — keep scroll position across option product navigations */
  options.forEach(function(option) {
    option.addEventListener('click', function(e) {
      if (this.classList.contains('custom-variant-selector__option--unavailable')) {
        e.preventDefault();
        return;
      }

      try {
        sessionStorage.setItem('pdp-v2-option-scroll-y', String(window.scrollY || window.pageYOffset || 0));
      } catch (err) {}

      selector.classList.add('custom-variant-selector__loading');

      const loadingSpinner = document.createElement('div');
      loadingSpinner.className = 'loading__spinner custom-variant-selector__loading-overlay';
      loadingSpinner.innerHTML = `
        <svg
          aria-hidden="true"
          focusable="false"
          class="spinner"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      `;

      selector.style.position = 'relative';
      selector.appendChild(loadingSpinner);
    });
  });
  
    options.forEach(function(option) {
      option.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!this.classList.contains('custom-variant-selector__option--unavailable')) {
            this.click();
          }
        }
      });
    });
}

function watchJsonModeContainers() {
  document.querySelectorAll('.custom-variant-selector[data-json-mode="true"]').forEach(function(container) {
    const loadingEl = container.querySelector('.custom-variant-selector__loading');
    if (!loadingEl) return;

    const observer = new MutationObserver(function() {
      if (!container.querySelector('.custom-variant-selector__loading')) {
        observer.disconnect();
        if (!container.querySelector('.custom-variant-selector__group')) {
          container.classList.add('custom-variant-selector--empty');
        }
      }
    });

    observer.observe(container, { childList: true, subtree: false });
  });
}